import { render, staticRenderFns } from "./ResourceCreateWrapper.vue?vue&type=template&id=9a44ee90&scoped=true&"
import script from "./ResourceCreateWrapper.vue?vue&type=script&lang=js&"
export * from "./ResourceCreateWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCreateWrapper.vue?vue&type=style&index=0&id=9a44ee90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a44ee90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
